import React, { useState } from "react";
import {
  CustomInput,
  Nav,
  NavItem,
  Button,
  TabContent,
  TabPane,
  Alert,
  FormFeedback,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useLocation } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  setBaseMap,
  setCitra,
  setHollowMaps,
  setTriggerRequest,
  setURLFilterByField,
} from "~/redux/actions";
import {
  FILTER_BIDANG_BY_FIELD,
  TIPE_PETA,
  replaceAll,
  ucFirst,
} from "~/utils";
import FilteredPeta from "~/pages/peta/peta-bidang/filtered-peta";

const TabsPeta = ({ children, handleSwitchMode, isBasedBidang, isBidang }) => {
  const [activeTab, setActiveTab] = useState("1");
  const { search: searchParams } = useLocation();
  const { handleSubmit, register, errors, watch, control } = useForm();

  const tipeQuery = new URLSearchParams(searchParams).get("tipe");

  const {
    citra,
    legends,
    bidangLayer,
    hollowMaps,
    activeList,
    loadingRenderMap,
  } = useSelector((state) => state.Map);

  const dispatch = useDispatch();
  const watchChooseSearch = watch("choose_search", null);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleSearchBidang = (values) => {
    const uriPayload = `&${values?.choose_search?.value}=${values?.search_input}`;

    dispatch(setURLFilterByField(uriPayload));
    dispatch(setTriggerRequest(true));
  };

  const isSelectConditional = bidangLayer === TIPE_PETA.BIDANG || isBasedBidang;
  const isLegendByType = legends?.filter((legend) => legend.tipe === tipeQuery);
  const isLegendNotByType = legends?.filter(
    (legend) => legend.tipe !== tipeQuery
  );

  return (
    <section>
      <Nav className="pr-2 pl-2 mb-2 mt-3 align-items-center">
        <NavItem>
          <Button
            color="link"
            className={activeTab === "1" && "border border-primary"}
            onClick={() => toggle("1")}
          >
            <i className="mdi mdi-layers-outline" />
          </Button>
        </NavItem>

        <NavItem>
          <Button
            color="link"
            className={activeTab === "2" && "border border-primary"}
            onClick={() => toggle("2")}
          >
            <i className="mdi mdi-map-legend" />
          </Button>
        </NavItem>

        <NavItem>
          <Button
            color="link"
            className={activeTab === "3" && "border border-primary"}
            onClick={() => toggle("3")}
          >
            <i className="mdi mdi-information-outline" />
          </Button>
        </NavItem>

        {isBidang && (
          <NavItem>
            <Button
              color="link"
              className={activeTab === "4" && "border border-primary"}
              onClick={() => toggle("4")}
            >
              <i className="mdi mdi-magnify" />
            </Button>
          </NavItem>
        )}

        {handleSwitchMode && (
          <NavItem className="ml-auto">
            <CustomInput
              type="switch"
              name="customSwitch"
              disabled={!activeList}
              id="exampleCustomSwitch"
              onChange={handleSwitchMode}
            />
          </NavItem>
        )}
      </Nav>

      <TabContent className="p-0" activeTab={activeTab}>
        <TabPane tabId="1">
          <section className="pb-2 mode-edit" />
          <div
            className="pr-2 pl-2 mb-3 pb-5"
            style={{ height: 650, overflow: "auto" }}
          >
            {isSelectConditional && (
              <>
                {!isBasedBidang && (
                  <Alert color="primary">
                    <i className="mdi mdi-information-outline mr-2" />
                    Lihat peta bidang
                  </Alert>
                )}
                <div className="mb-3">
                  <FilteredPeta isBasedBidang={isBasedBidang} />
                </div>
              </>
            )}

            <Alert color="primary">
              <i className="mdi mdi-information-outline mr-2" />
              Basemap
            </Alert>

            <div className="mt-3">
              <CustomInput
                className="mb-3"
                type="radio"
                name="google"
                id="googlemap"
                label="Google Map"
                defaultChecked
                onChange={(e) => dispatch(setBaseMap(e.target.id))}
              />
              <CustomInput
                className="mb-3"
                type="radio"
                name="google"
                id="googlesatelite"
                label="Google Satelite"
                onChange={(e) => dispatch(setBaseMap(e.target.id))}
              />
            </div>

            <Alert color="primary">
              <i className="mdi mdi-information-outline mr-2" />
              Maps
            </Alert>

            <div className="mt-3">
              <CustomInput
                className="mb-3"
                type="checkbox"
                name="citra"
                id="citra"
                label="Citra"
                defaultChecked={citra}
                onChange={(e) => dispatch(setCitra(e.target.checked))}
              />

              <CustomInput
                className="mb-3"
                type="checkbox"
                name="hollow_maps"
                id="hollow_maps"
                label="Hollow Maps"
                defaultChecked={hollowMaps}
                onChange={(e) => dispatch(setHollowMaps(e.target.checked))}
              />
            </div>
          </div>
        </TabPane>
        <TabPane tabId="2">
          <section className="pb-2 mode-edit" />
          <div className="pr-2 pl-2 mb-3">
            <Alert color="primary" className="mb-3">
              <i className="mdi mdi-information-outline mr-2" />
              Legenda
            </Alert>

            <div style={{ height: "calc(100vh - 250px)", overflow: "auto" }}>
              {isLegendByType?.length > 0 && (
                <div className="mb-2">
                  <small className="mb-2">
                    {replaceAll(ucFirst(isLegendByType?.[0]?.tipe), "_", " ")}
                  </small>

                  {isLegendByType?.map((legend, idx) => (
                    <div
                      key={`${legend.ket_color}-${idx}`}
                      className="d-flex align-items-center mx-auto mb-2"
                    >
                      <span
                        style={{
                          position: "relative",
                          width: "10%",
                          height: "15px",
                          backgroundColor: legend.warna,
                        }}
                      />
                      <span className="ml-2">{legend.ket_color}</span>
                    </div>
                  ))}
                </div>
              )}

              {isLegendNotByType?.length > 0 && (
                <div className="mb-2">
                  <small className="mb-2">
                    {replaceAll(
                      ucFirst(isLegendNotByType?.[0]?.tipe),
                      "_",
                      " "
                    )}
                  </small>

                  {isLegendNotByType?.map((legend, idx) => (
                    <div
                      key={`${legend.ket_color}-${idx}`}
                      className="d-flex align-items-center mx-auto mb-2"
                    >
                      <span
                        style={{
                          position: "relative",
                          width: "10%",
                          height: "15px",
                          backgroundColor: legend.warna,
                        }}
                      />
                      <span className="ml-2">{legend.ket_color}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* {sigTipeData?.keterangan && (
              <div className="d-block">
                <i className="mdi mdi-information-outline mb-1" />
                <p className="mb-0">{sigTipeData?.keterangan}</p>
              </div>
            )} */}
          </div>
        </TabPane>
        <TabPane tabId="3">{children}</TabPane>

        <TabPane tabId="4">
          <section className="pb-2 mode-edit" />
          <div
            className="pr-2 pl-2 mb-3 pb-5"
            style={{ height: 650, overflow: "auto" }}
          >
            <Alert color="primary">
              <i className="mdi mdi-information-outline mr-2" />
              Pencarian Pemilik / Penguasa
            </Alert>

            <form
              autoComplete="off"
              onSubmit={handleSubmit(handleSearchBidang)}
            >
              <FormGroup>
                <Label>Pilih pencarian</Label>
                <Controller
                  name="choose_search"
                  control={control}
                  rules={{ required: true }}
                  render={({ onChange }) => (
                    <Select
                      onChange={(val) => onChange(val)}
                      placeholder="Pilih pencarian"
                      options={FILTER_BIDANG_BY_FIELD.LISTS}
                    />
                  )}
                />

                {errors?.choose_search && (
                  <FormFeedback className="d-block">
                    Pilih pencarian
                  </FormFeedback>
                )}
              </FormGroup>

              {watchChooseSearch?.value && (
                <FormGroup>
                  <Label>Cari menggunakan {watchChooseSearch?.label}</Label>
                  <Input
                    name="search_input"
                    invalid={errors?.search_input}
                    placeholder={`Ketikkan ${watchChooseSearch?.label}`}
                    innerRef={register({ required: true })}
                  />

                  {errors?.search_input && (
                    <FormFeedback>
                      Masukkan {watchChooseSearch?.label}
                    </FormFeedback>
                  )}
                </FormGroup>
              )}

              <Button
                block
                type="submit"
                color="primary"
                className="mt-3"
                disabled={loadingRenderMap}
              >
                {loadingRenderMap ? "memuat peta..." : "Lihat"}
              </Button>
            </form>
          </div>
        </TabPane>
      </TabContent>
    </section>
  );
};

export default TabsPeta;
